module.exports = __webpack_public_path__ + "img/RayqeeLogoo.5d607fe7.png";